import React from "react";
import T from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import {
  form,
  Form as AppForm,
  NumberInput
} from "MODULES/shared/components/Forms";
import validate from "./validate";

function Form(props) {
  const { inventoryQuantity, change } = props;
  const handleQtyChange = qty => {
    const remaining = qty >= 0 ? inventoryQuantity - qty : inventoryQuantity;
    change("remaining_quantity", remaining);
  };

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row>
          <Col md={12}>
            <Field
              name="remaining_quantity"
              label="Remaining QTY"
              component={NumberInput}
              roundDigits={0}
              readOnly
              disabled
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Field
              name="quantity"
              label="QTY"
              component={NumberInput}
              roundDigits={0}
              inputProps={{ min: 0 }}
              onChange={(ev, val) => handleQtyChange(val)}
              required
            />
          </Col>
        </Row>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  change: T.func.isRequired,
  inventoryQuantity: T.number.isRequired
};

export default connect(
  state => ({
    inventoryQuantity: state.inventoryDetail.getIn(["inventory", "quantity"])
  }),
  (dispatch, ownProps) => ({
    onSubmit: data => dispatch(ownProps.submitAction(data))
  })
)(
  form({
    form: "splitInventory",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/SplitInventory/Form.jsx